import type { OnboardingStatus } from "@xop-any-time/shared";
import { Box, Typography } from "@mui/material";
import type { JSX } from "react";

import { CHANNEL_MANAGER_LINE, WallCard } from "./OnboardingLayout.js";

/** The terminal state (spec E §10.2). Rejection is terminal in v1; staff can
 * reopen from the command center, and the line at the bottom is how the
 * applicant asks. */
export function RejectedState({ status }: { status: OnboardingStatus }): JSX.Element {
  return (
    <WallCard title="Application not approved">
      <Typography component="p" sx={{ mt: 0.75, fontSize: 13.5, lineHeight: 1.6, color: "text.secondary" }}>
        XOP Networks reviewed your application and was not able to approve it
        {status.decidedAt ? ` on ${new Date(status.decidedAt).toLocaleDateString(undefined, { dateStyle: "medium" })}` : ""}.
      </Typography>
      {status.decisionNote && (
        <Box sx={{ mt: 2.5, borderRadius: 1.5, border: 1, borderColor: "divider", px: 2, py: 1.5 }}>
          <Typography component="p" sx={{ fontSize: 11, fontWeight: 600, letterSpacing: "0.06em", textTransform: "uppercase", color: "text.secondary" }}>
            From XOP Networks
          </Typography>
          <Typography component="p" sx={{ mt: 0.5, fontSize: 14, lineHeight: 1.6 }}>{status.decisionNote}</Typography>
        </Box>
      )}
      <Typography component="p" sx={{ mt: 3, pt: 2.5, borderTop: 1, borderColor: "divider", fontSize: 12, color: "text.secondary" }}>
        {CHANNEL_MANAGER_LINE}
      </Typography>
    </WallCard>
  );
}
